import React, { useEffect, useState } from 'react';
import { Zap } from 'lucide-react';
import { INSHUR_YELLOW } from './shared';

const HOLD_MS = 6000;

/**
 * Slim announcement bar for the limited-time INSHUR promo. Opens the
 * header-less page, stepping through its messages and holding each for
 * 6 seconds with a vertical slide. Pauses on hover.
 */
const AnnouncementBar = () => {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return undefined;
    const id = setInterval(() => {
      setIndex((prev) => (prev + 1) % 2);
    }, HOLD_MS);
    return () => clearInterval(id);
  }, [paused]);

  return (
    <div
      className="ilp-announce"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-label="Promotional announcement"
    >
      <div className="ilp-announce-viewport">
        <div className="ilp-announce-track" style={{ transform: `translateY(-${index * 100}%)` }}>
          <div className="ilp-announce-slide" aria-hidden={index !== 0}>
            <span className="ilp-announce-msg">
              <Zap className="ilp-announce-icon" style={{ color: INSHUR_YELLOW }} aria-hidden="true" />
              <span className="ilp-announce-lead">Limited offer NEW Inshur customers:</span>
              <span>
                Enjoy{' '}
                <span className="ilp-announce-accent" style={{ color: INSHUR_YELLOW }}>
                  ZERO
                </span>{' '}
                Onboarding Fees and{' '}
                <span className="ilp-announce-accent" style={{ color: INSHUR_YELLOW }}>
                  FREE
                </span>{' '}
                Website with sign up.
              </span>
            </span>
          </div>

          <div className="ilp-announce-slide" aria-hidden={index !== 1}>
            <a href="/inshur" className="ilp-announce-link">
              <Zap className="ilp-announce-icon" style={{ color: INSHUR_YELLOW }} aria-hidden="true" />
              Learn more about the Rentid and INSHUR partnership.
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnnouncementBar;
